var React = require('react');

function Search (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M21.5647 21.5657C21.0892 22.0405 20.3183 22.038 19.8458 21.5602C18.2826 19.9793 15.0379 16.6993 14.0543 15.7169C10.8489 18.0433 6.39127 17.5162 3.81834 14.5065C1.24541 11.4968 1.4226 7.01689 4.22521 4.2193C7.02782 1.42171 11.5132 1.24747 14.5249 3.8192C17.5365 6.39093 18.0615 10.8436 15.7304 14.0438C16.8077 15.1183 20.0116 18.3051 21.5637 19.8489C22.0396 20.3222 22.0397 21.0914 21.5647 21.5657ZM9.56556 4.31096C6.65395 4.3135 4.29545 6.67265 4.29714 9.58082C4.29884 12.489 6.66009 14.8454 9.5717 14.8445C12.4833 14.8437 14.8432 12.4859 14.8432 9.57775C14.8415 6.66749 12.4782 4.30954 9.56454 4.31096H9.56556Z","fill":"white"}));
}

Search.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Search;

Search.default = Search;
